/**
 * Bildirim bandı sayacı artınca, site bildirimi açıksa tarayıcı bildirimi.
 * İlk görülen değer taban çizgisidir; sayfa açılışındaki mevcut sayı bildirim üretmez.
 */

export function createBandAnnouncer(notifyFn) {
  const baselines = new Map();
  return function publish(key, count, payload = {}) {
    const name = String(key || '').trim();
    if (!name) return { announced: false, seeded: false };
    const next = Math.max(0, Number(count) || 0);
    if (!baselines.has(name)) {
      baselines.set(name, next);
      return { announced: false, seeded: true, count: next };
    }
    const prev = baselines.get(name);
    baselines.set(name, next);
    if (next > prev) {
      if (typeof notifyFn === 'function') {
        notifyFn({
          tag: name,
          title: payload.title || 'Point CRM',
          body: payload.body || '',
          count: next,
          delta: next - prev,
        });
      }
      return { announced: true, seeded: false, count: next, delta: next - prev };
    }
    return { announced: false, seeded: false, count: next };
  };
}

let permissionAskArmed = false;

/** İzin sorusu sayfa açılınca, tarayıcı bunu yutarsa ilk tıklamada çıkar. */
export function requestBrowserNotificationPermission() {
  if (typeof Notification === 'undefined' || typeof window === 'undefined') return;
  if (Notification.permission !== 'default' || permissionAskArmed) return;
  permissionAskArmed = true;

  const ask = () => {
    if (typeof Notification === 'undefined' || Notification.permission !== 'default') return;
    try {
      const pending = Notification.requestPermission();
      if (pending && typeof pending.then === 'function') pending.catch(() => {});
    } catch (_) { /* ignore */ }
  };

  ask();
  const onGesture = () => {
    window.removeEventListener('pointerdown', onGesture, true);
    window.removeEventListener('keydown', onGesture, true);
    ask();
  };
  window.addEventListener('pointerdown', onGesture, true);
  window.addEventListener('keydown', onGesture, true);
}

export function showBrowserNotification({ tag, title, body } = {}) {
  if (typeof Notification === 'undefined') return false;
  if (Notification.permission !== 'granted') return false;
  const heading = String(title || 'Point CRM').trim() || 'Point CRM';
  const text = String(body || '').trim();
  try {
    const note = new Notification(heading, {
      body: text,
      tag: tag || heading,
      renotify: true,
      icon: '/favicon.png',
    });
    note.onclick = () => {
      try { window.focus(); } catch (_) { /* ignore */ }
      note.close();
    };
    return true;
  } catch (_) {
    return false;
  }
}

const announcer = createBandAnnouncer(showBrowserNotification);

export function publishBandCount(key, count, payload) {
  return announcer(key, count, payload);
}
